const projectView = true;

// console.disableYellowBox = true;
const consoleWarn = console.warn;
const consoleError = console.error;
const SUPPRESSED_WARNINGS = [
  "ImmutableStateInvariantMiddleware",
  "Unknown event handler property",
  "for a non-boolean attribute",
  "inside passive event listener invocation",
  "focusable is deprecated",
];
console.warn = function filterWarnings(msg, ...args) {
  let msgString = msg.toString();
  if (!SUPPRESSED_WARNINGS.some((entry) => msgString.includes(entry))) {
    consoleWarn(msg, ...args);
  }
};
console.error = function filterErrors(msg, ...args) {
  let msgString = msg.toString();
  // console.log(msgString);
  if (!SUPPRESSED_WARNINGS.some((entry) => msgString.includes(entry))) {
    consoleError(msg, ...args);
  } else {
    console.log(`shhh ${msg}`);
  }
};

// In App.js in a new project
import * as React from "react";
import Constants from "expo-constants";
import * as Device from "expo-device";

// import { watchEvents } from "react-native-watch-connectivity";

import * as Updates from "expo-updates";
import { Provider } from "react-redux";
import storageActions from "app/utils/storageActions";
import store from "app/redux/store";
import { index } from "app/actions/values";
import { setLoading, setLocalLoading, setUpdatedAt } from "app/actions/app";
// import { setPreferences, } from 'app/actions/preferences'
import { StyleProvider } from "app/contexts/Style";
import authActions from "app/utils/authActions";
import ENV from "app/utils/ENV";

import Text from "app/components/Text";

try {
  if (ENV.WEB) require("./style.css");
} catch (e) {
  // console.warn(e);
}

import {
  View,
  StatusBar,
  Platform,
  ActivityIndicator,
  Alert,
  AppState,
} from "react-native";

import prefActions from "app/utils/prefActions";
import valueActions from "app/utils/valueActions";
import alertActions from "app/utils/alertActions";
import offlineQueue from "app/utils/offlineQueue";
import OfflineBanner from "app/components/OfflineBanner";

import * as SplashScreen from "expo-splash-screen";
import { navigationRef } from "app/utils/RootNavigation";
import * as RootNavigation from "app/utils/RootNavigation";
import { styleSheet, colors } from "app/utils/styleSheet";
import notificationHelpers from "app/utils/notificationHelpers";
import iconHelpers from "app/utils/iconHelpers";
import calendarActions from "app/utils/calendarActions";

import AuthScreen from "app/views/AuthScreen";
import Router from "app/Router";
import RouterPensieve from "app/RouterPensieve";

// import * as Font from "expo-font";
import {
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  AntDesign,
  FontAwesome5,
  Fontisto,
  Entypo,
  Octicons,
  Foundation,
  FontAwesome,
  Feather,
} from "@expo/vector-icons";

import * as Sentry from "@sentry/react-native";

try {
  SplashScreen.preventAutoHideAsync();
} catch (e) {
  // console.warn(e);
}

Sentry.init({
  dsn: "https://beb43671dab54bcfae700055cb8b909d@o1237509.ingest.sentry.io/6387859",
  enableInExpoDevelopment: false,
  debug: true, // If `true`, Sentry will try to print out useful debugging
  // information if something goes wrong with sending the event.
  // Set it to `false` in production
});

export default class App extends React.Component {
  async componentDidMount() {
    // console.warn(watchEvents);
    this.checkUpdates();
    this.appStateListener = AppState.addEventListener(
      "change",
      this._handleAppStateChange,
    );
    await iconHelpers._loadAssetsAsync();
    offlineQueue.loadIntoRedux();
    this.setupNetworkListeners();
    this.unsubscribeOfflineWatch = store.subscribe(() => {
      const isOnline = store.getState().app?.isOnline;
      if (isOnline === false) this.startOfflinePoller();
      else if (isOnline === true) this.clearOfflinePoller();
    });

    let token = await storageActions.fetchItem("token", null);
    if (!token && ENV.autoToken) {
      await storageActions.saveItem("token", ENV.autoToken);
      token = ENV.autoToken;
    }
    await this.setState({ token, tokenFetched: true });

    let pensieve = await storageActions.fetchItem("pensieve", true);
    let demo = await storageActions.fetchItem("demo");
    let listLayout = await storageActions.fetchItem("listLayout");
    let preferences = (await storageActions.fetchItem("preferences")) || {};
    // console.warn(preferences);
    store.dispatch({ type: "preferences/update", preferences });
    store.dispatch(setLoading(false));
    this.setState({
      preferences,
      prefsFetched: true,
      pensieve,
      demo,
      listLayout,
    });
    // return;

    store.dispatch(setLocalLoading(false));

    // Hide the splash as soon as cached/local data is ready — never block it on the
    // network. If the server fetch below fails (offline / flaky wifi), the app still
    // opens with cached data; offlineQueue + the network poller resync when wifi returns.
    try {
      // await SplashScreen.preventAutoHideAsync();
      await SplashScreen.hideAsync();
    } catch (e) {
      // console.warn(e);
    }

    // fetch server data (best-effort — must not be able to wedge startup)
    console.log("------begin pref fetch");
    let fetchedPreferences;
    try {
      fetchedPreferences = await prefActions.get(true);
      console.log("------completed pref fetch", fetchedPreferences);
    } catch (e) {
      console.warn("[App] initial pref fetch failed; using cached prefs", e);
    }

    console.log("=== REGISTERING FOR PUSH NOTIFICATIONS ===");
    let notifToken =
      await notificationHelpers.registerForPushNotificationsAsync();
    console.log("Received notif token:", notifToken);
    if (notifToken) {
      this.setState({ notifToken });
      console.log("Calling updateNotifToken API...");
      let result = await authActions.updateNotifToken(notifToken);
      console.log("updateNotifToken result:", result);

      // Alert only if API call failed
      if (__DEV__ && result && result.success === false) {
        alert("❌ Token saved locally but API call failed!\n\nCheck your network connection.");
      } else if (__DEV__ && result && result.success === true) {
        alert("✅ Token registered successfully!\n\nPush notifications should work now.");
      }
    } else {
      console.log("❌ No notification token received - permissions might be denied or device issue");
    }

    calendarActions.syncIfAuthenticated();

    if (ENV.WEB) {
      // document.addEventListener("keyup", this.handleKeyUp);
      // document.addEventListener("keydown", this.handleKeyDown);
    }
  }

  componentWillUnmount() {
    if (ENV.WEB) {
      // document.removeEventListener("keyup", this.handleKeyUp);
      // document.removeEventListener("keydown", this.handleKeyDown);
    }
    this.appStateListener?.remove();
    this.teardownNetworkListeners();
    this.unsubscribeOfflineWatch?.();
  }

  setupNetworkListeners = () => {
    if (ENV.WEB && typeof window !== "undefined") {
      window.addEventListener("online", this.handleNetworkOnline);
      window.addEventListener("offline", this.handleNetworkOffline);
      if (!window.navigator.onLine) offlineQueue.markOffline();
    }
  };

  teardownNetworkListeners = () => {
    if (ENV.WEB && typeof window !== "undefined") {
      window.removeEventListener("online", this.handleNetworkOnline);
      window.removeEventListener("offline", this.handleNetworkOffline);
    }
    this.clearOfflinePoller();
  };

  handleNetworkOnline = () => {
    offlineQueue.markOnline();
    this.clearOfflinePoller();
  };

  handleNetworkOffline = () => {
    offlineQueue.markOffline();
    this.startOfflinePoller();
  };

  startOfflinePoller = () => {
    if (this.offlinePoller) return;
    this.offlinePoller = setInterval(this.probeNetwork, 5000);
  };

  clearOfflinePoller = () => {
    if (this.offlinePoller) {
      clearInterval(this.offlinePoller);
      this.offlinePoller = null;
    }
  };

  probeNetwork = async () => {
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      await fetch(ENV.ROOT, { method: "HEAD", signal: controller.signal });
      clearTimeout(timeout);
      offlineQueue.markOnline();
      this.clearOfflinePoller();
    } catch (e) {
      // still offline
    }
  };

  handleKeyUp = (e) => {
    // console.log("handle key up", e.key);
    if (e.key == "Meta") {
      store.dispatch({ type: "dragging/set_value", metaKey: false });
    }
  };

  handleKeyDown = (e) => {
    // console.log("handle key down", e.key);
    if (!this.state.token) return;
    if (e.key == "Meta") {
      store.dispatch({ type: "dragging/set_value", metaKey: true });
    }
    // alert(e.key);
  };

  constructor(props) {
    super(props);
    this.state = {
      key: 0,
      isReady: false,
      prefsFetched: false,
      tokenFetched: false,
      token: null,
      intro: false,
      showKeyboardShortcuts: false,
      showAbout: false,
      showSettings: false,
      notifToken: null,
      // showKeyboardShortcuts: true,
      downloadingOta: false,
      appState: AppState.currentState,
    };
  }

  render() {
    let {
      prefsFetched,
      tokenFetched,
      token,
      intro,
      preferences,
      downloadingOta,
    } = this.state;
    if (!prefsFetched || !tokenFetched) {
      return <ActivityIndicator />;
    }

    let otaBanner = null;
    if (downloadingOta) {
      otaBanner = (
        <View
          style={{
            width: "100%",
            backgroundColor: "#44dd97",
            justifyContent: "flex-end",
            alignItems: "center",
            paddingTop: Constants.statusBarHeight + 10,
            paddingBottom: 10,
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 999,
          }}
        >
          <Text light>Downloading update...</Text>
        </View>
      );
    }

    if (!token) {
      return (
        <StyleProvider preferences={preferences}>
          {otaBanner}
          <AuthScreen
            onSetToken={async (tkn, intro) => {
              await this.setState({ token: tkn, intro });
              authActions.updateNotifToken(this.state.notifToken);
            }}
          />
        </StyleProvider>
      );
    }

    return (
      <StyleProvider
        preferences={preferences}
        pensieve={this.state.pensieve}
        demo={this.state.demo}
        listLayout={this.state.listLayout}
      >
        <Provider store={store}>
          {otaBanner}
          {projectView ? (
            <Router
              intro={intro}
              clearToken={() => this.setState({ token: null })}
            />
          ) : (
            <RouterPensieve
              intro={intro}
              clearToken={() => this.setState({ token: null })}
            />
          )}
          <View
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              zIndex: 9999,
            }}
          >
            <OfflineBanner />
          </View>
        </Provider>
      </StyleProvider>
    );
  }

  render_xxxxx() {
    let { prefsFetched, tokenFetched, token, valueId, intro, preferences } =
      this.state;
    if (!prefsFetched || !tokenFetched) {
      return <ActivityIndicator />;
    }

    if (!token) {
      return (
        <StyleProvider preferences={preferences}>
          <AuthScreen
            onSetToken={async (tkn, intro) => {
              await this.setState({ token: tkn, intro });
              authActions.updateNotifToken(this.state.notifToken);
            }}
          />
          ;
        </StyleProvider>
      );
    }

    return (
      <StyleProvider
        preferences={preferences}
        pensieve={this.state.pensieve}
        demo={this.state.demo}
        listLayout={this.state.listLayout}
      >
        <Provider store={store}>
          <Router
            valueId={valueId}
            intro={intro}
            clearToken={() => this.setState({ token: null })}
          />
        </Provider>
      </StyleProvider>
    );
  }

  _handleAppStateChange = (nextAppState) => {
    if (
      this.state.appState.match(/inactive|background/) &&
      nextAppState === "active"
    ) {
      this.checkUpdates();
      calendarActions.syncIfAuthenticated();
      this.probeNetwork();
    }
    this.setState({ appState: nextAppState });
  };

  checkUpdates = async () => {
    if (ENV.WEB || !Device.isDevice) return;
    const update = await Updates.checkForUpdateAsync();
    if (update.isAvailable) {
      console.log("An update was found, downloading....");
      this.setState({ downloadingOta: true });
      let res = await Updates.fetchUpdateAsync();
      this.setState({ downloadingOta: false });
      Alert.alert(`Update is ready.`, `Relaunch the app now?`, [
        {
          text: `Later`,
          onPress: () => {
            return null;
          },
          style: "destructive",
        },
        {
          text: `Relaunch`,
          onPress: () => {
            Updates.reloadAsync();
          },
          style: "default",
        },
      ]);
    }
  };
}
